<template>
  <div class="demo-button d-flex align-items-center justify-content-center">
    <div class="icon d-flex align-items-center justify-content-center" :class="classList">
      <div class="active-indicator" :class="{ active: isActive }"></div>
      <div class="indicator-pulse" :class="{ active: isActive }"></div>
      <component ref="icon"
        :is="icon"
        :complete="isComplete"
        :active="isActive" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'demo-button',
  props: ['idx', 'icon', 'namespace'],
  computed: {
    isComplete () {
      return this.complete || false
    },
    isActive () {
      return this.active || false
    },
    classList () {
      return {
        enabled: this.enabled || typeof this.enabled === 'undefined',
        complete: this.complete || typeof this.complete === 'undefined'
      }
    }
  },
  beforeCreate () {
    // Need to dynamically map state to computed properties if namespace prop is supplied
    let ns = this.$options.propsData.namespace
    if ( ns ) {
      this.$options.computed = {
        ...this.$options.computed,
        ...mapState( ns, {
          enabled ( state ) {
            return state.enabled
          },
          complete ( state ) {
            return state.complete
          },
          active ( state ) {
            return state.active
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/global/the_goods";

@keyframes scalePulse {
  0% {
    transform : scale(0.9);
  }
  50% {
    transform : scale(1.05);
  }
  100% {
    transform : scale(0.9);
  }
}

.demo-button {
  flex-grow       : 1;
  pointer-events  : auto;

  .icon {
    position    : relative;
    width       : 50px;
    height      : 50px;
    opacity     : 0.2;
    transition  : all 500ms cubic-bezier(0.645, 0.000, 0.355, 1.000);

    .icon-vector {
      height : 90%;
    }

    .active-indicator,
    .indicator-pulse {
      position          : absolute;
      top               : 0;
      left              : 0;
      width             : 100%;
      height            : 100%;
      background        : rgba(250, 250, 250, 0.75);
      border-radius     : 50%;
      z-index           : 0;
      transform-origin  : 50% 50%;
      transform         : scale(0);
      transition        : transform 0.5s cubic-bezier(0.645, 0.000, 0.355, 1.000);

      &.active {
        transform : scale(0.9);
      }
    }

    .indicator-pulse {
      // transition: none;
      background : rgba(200, 200, 200, 0.5);
      z-index : -1;

      &.active {
        animation : 2s cubic-bezier(0.645, 0.000, 0.355, 1.000) 0.5s infinite scalePulse;
      }
    }

    &.enabled {
      opacity : 1;
    }

    svg {
      height          : 100%;
      pointer-events  : none;
      z-index         : 2; 
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/demos/DemoButton.vue